// extracted by mini-css-extract-plugin
module.exports = {"error":"NRk1FOp9WGFCUlBTtzQHM","success":"I-9jYzdc9zx2NhJRjjK2L"};